import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import StaffTableSnippet from '../../elements/StaffTableSnippet'
import Loader from '../../elements/Loader'
import EmptyState from '../../elements/EmptyState'
import DataTable from '../../elements/DataTable'
import { authHeader, baseUrl, tableHeadersFields } from '../../../utils'
import moment from 'moment'
import axios from 'axios'
import { ERROR } from '../../../store/types'
import ChevronIcon from '../../elements/icons/ChevronIcon'

const Assessment = ({assessment, student}) => {
    const dispatch = useDispatch()
    const [loadingRecords, setLoadingRecords] = useState(true)
    const [records, setRecords] = useState(null)

    const transactionColumnWidths = {
        // student: 'w-3/12',
        subject: 'w-3/12',
        // session: 'w-3/12',
        score: 'w-3/12',
        recordedBy: 'w-4/12',
        dateRecorded: 'w-2/12',
    }
        
    const tableOptions = {
        selectable: false,
        clickableRows: true,
        rowAction: (index)=>{}
    }
    
    const columnDataStyles = {}

    const cleanupData = (dataSet) => {
        if(!dataSet) return []
        const data = []

        dataSet.forEach((item, itemIndex) => {
            data.push(
                {
                    subject: <p className='text-sm'>{item.subject.name}</p> ,
                    recordedBy: <StaffTableSnippet staff={item.recordedBy} hidePhoto />,
                    score:
                    <p className='font-space-grotesk font-medium text-[16px]'>
                        <span className={`font-space-grotesk p-[5px] mr-[10px] rounded text-[14px] 
                        ${item.percentageScore >= 70 && 'bg-green-100 text-green-800' }
                        ${item.percentageScore >= 50 && item.percentageScore < 70 && 'bg-gray-100 text-gray-800' }
                        ${item.percentageScore < 50 && 'bg-red-100 text-red-800' }
                        `}>
                        {item.percentageScore}%
                        </span>
                        {item.score}/<span className='text-gray-400'>{item.outOf}</span> 
                    </p>,
                    dateRecorded: `${new Date(item.createdAt).toDateString()} - ${new Date(item.createdAt).toLocaleTimeString()}`,
                },
            )
        })

        return data
    }

    const [assessmentRecordsOpen, setAssessmentRecordsOpen] = useState(false)

    const fetchAssessmentRecords = async () => {    
        try{
            const headers = authHeader()

            let url = `${baseUrl}/assessment-records/student/${student._id}?assessment=${assessment._id}&expand=student,recordedBy,class.class,academicSession,term,subject`

            setLoadingRecords(true)

            const response = await axios.get(url, { headers })

            setRecords(response.data.data.assessmentRecords)

            setLoadingRecords(false)
            
        }
        catch(error){
            dispatch( {
                type: ERROR,
                error
            })
        }
    }  


    const toggleAssessmentRecords = () => {
        if(!assessmentRecordsOpen) {
            fetchAssessmentRecords()
            setAssessmentRecordsOpen(true)
        } else {
            setAssessmentRecordsOpen()
            setTimeout(() => {
                setRecords(null)
            }, 50);
        }
    }

    return (
        <div className='w-full p-[15px] lg:p-[20px] rounded border border-gray-200'>
            <div className='w-full lg:flex items-start justify-between gap-x-2'>
                <div className="w-full">
                    <div className='lg:flex items-start gap-x-[5px]'>
                        <h3 className='font-space-grotesk text-md font-[550] mb-1'>{assessment.name}</h3>
                        {assessment.type==='continuous-assessment' ? <span className='px-[10px] py-[5px] inline-block rounded bg-yellow-500 text-yellow-800 bg-opacity-10 text-xs font-medium font-space-grotesk'>
                            Continuous Assessment
                            </span>
                            :
                            <span className='px-[10px] py-[5px] inline-block rounded bg-green-500 text-green-800 bg-opacity-10 font-medium font-space-grotesk text-xs'>
                            Term Examination
                            </span>
                        }
                    </div>
                    <p className='text-sm my-2 lg:w-7/12 text-gray-600'>{assessment.description}</p>
                    <div className='mt-[10px]'>
                        <p className='text-sm font-medium text-gray-600'>{assessment.term.name} - {assessment.academicSession.name}</p>
                        <p className='text-sm mt-[5px] font-medium text-gray-800'>From {moment(assessment.dates.from).format('LL')} to {moment(assessment.dates.to).format('LL')}</p>
                    </div>
                </div>

                <button onClick={() => {toggleAssessmentRecords()}} className='w-full lg:w-[120px] mt-3 lg:mt-0 font-space-grotesk font-[600] rounded text-xs text-gray-600 bg-gray-100 lg:bg-transparent hover:text-gray-400 flex items-center justify-center gap-x-[5px] p-4 lg:p-0'>
                    {assessmentRecordsOpen ? 'Hide' : 'Show'} Scores 
                    <ChevronIcon className={`w-4 h-4 transition duration-200 ${assessmentRecordsOpen ? 'rotate-[180deg]' : 'rotate-[270deg]'} `} />
                </button>
            </div>

            {assessmentRecordsOpen && <div className='mt-[10px]'>
                {loadingRecords ? 
                    <Loader />
                    :
                    <>
                    {records?.length === 0 ? 
                        <div className='w-full'>
                        <EmptyState emptyStateText={`No scores recorded for this assessment yet. Please check back later.`} />
                        </div>
                    :
                    <>
                        <div className='w-full hidden xl:block'>
                        <DataTable
                            tableHeaders={tableHeadersFields(cleanupData(records)[0]).headers} 
                            tableData={cleanupData(records)} 
                            columnWidths={transactionColumnWidths}
                            columnDataStyles={columnDataStyles}
                            allFields={tableHeadersFields(cleanupData(records)[0]).fields}
                            onSelectItems={()=>{}}
                            tableOptions={tableOptions}
                        />
                        </div>
                        <div className='xl:hidden w-full space-y-3'>
                        {records?.map((record, index) => (
                            <div key={index} className='bg-white border border-gray-200 rounded-lg p-4 shadow-sm'>
                            <div className='flex items-start justify-between mb-3'>
                                <div className='flex-1'>
                                <h5 className='font-medium text-gray-800 mb-1'>{record.subject.name}</h5>
                                {/* <p className='text-xs text-gray-500'>{record.academicSession.name} - {record.term.name}</p> */}
                                </div>
                                <div className='text-right'>
                                <span className={`inline-block font-space-grotesk px-2 py-1 rounded text-sm font-medium
                                    ${record.percentageScore >= 70 && 'bg-green-100 text-green-800'}
                                    ${record.percentageScore >= 50 && record.percentageScore < 70 && 'bg-gray-100 text-gray-800'}
                                    ${record.percentageScore < 50 && 'bg-red-100 text-red-800'}
                                `}>
                                    {record.percentageScore}%
                                </span>
                                </div>
                            </div>
                            
                            <div className='space-y-2 mb-3'>
                                <div className='flex justify-between items-center'>
                                <span className='text-xs text-gray-600'>Score</span>
                                <span className='font-space-grotesk font-medium text-sm'>
                                    {record.score}/<span className='text-gray-400'>{record.outOf}</span>
                                </span>
                                </div>
                                <div className='flex justify-between items-start'>
                                <span className='text-xs text-gray-600'>Recorded by</span>
                                <div className='text-right'>
                                    <StaffTableSnippet staff={record.recordedBy} hidePhoto />
                                </div>
                                </div>
                            </div>
                            
                            <div className='pt-2 border-t border-gray-100'>
                                <p className='text-xs text-gray-500'>
                                {new Date(record.createdAt).toDateString()} - {new Date(record.createdAt).toLocaleTimeString()}
                                </p>
                            </div>
                            </div>
                        ))}
                        </div>
                    </>
                    }
                    </>
                }
            </div>}
        </div>
    )
}

export default Assessment